import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import Modal from '../../../components/modals/Modal';
import AuthFlow from './AuthFlow';

@connect(({auth}) => ({token: auth.token}))
export default class AuthFlowModal extends React.PureComponent {
  static modalName = 'auth';

  componentDidUpdate(prevProps) {
    const {token, onClose} = this.props;

    if (token && !prevProps.token) {
      onClose();
    }
  }

  render() {
    const {page, onClose, initialState} = this.props;

    return (
      <Modal type={page && 'page'} onClose={onClose}>
        <AuthFlow initialState={initialState}/>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/auth/modals/AuthFlowModal.js